<template>
  <nav
    class="py-4 flex flex-wrap justify-center items-center gap-x-3 gap-y-2"
    aria-label="Choose your language"
  >
    <template v-for="l in langs" :key="l.code">
      <span
        v-if="l.code === current"
        class="px-2 py-1 font-arial text-[14px] md:text-[15px] font-bold text-white border-b-2 border-[#FF0000]"
        aria-current="page"
        >{{ l.name }}</span
      >
      <a
        v-else
        :href="l.path"
        :lang="l.code"
        class="px-2 py-1 font-arial text-[14px] md:text-[15px] font-bold text-[#FF0000] hover:underline"
        >{{ l.name }}</a
      >
    </template>
  </nav>
</template>

<script>
// Top-of-page language switcher for the rally-roadbook pillar pages. Uses real
// <a href> links (not router-link) so every localized page is a crawlable link
// in the prerendered HTML. Native names so each speaker recognizes their own.
const LANGS = [
  { code: 'en', name: 'English', path: '/rally-roadbook' },
  { code: 'de', name: 'Deutsch', path: '/de/rally-roadbook' },
  { code: 'fr', name: 'Français', path: '/fr/rally-roadbook' },
  { code: 'es', name: 'Español', path: '/es/rally-roadbook' },
  { code: 'it', name: 'Italiano', path: '/it/rally-roadbook' },
  { code: 'pt', name: 'Português', path: '/pt/rally-roadbook' },
  { code: 'nl', name: 'Nederlands', path: '/nl/rally-roadbook' },
  { code: 'pl', name: 'Polski', path: '/pl/rally-roadbook' },
  { code: 'cs', name: 'Čeština', path: '/cs/rally-roadbook' },
  { code: 'fi', name: 'Suomi', path: '/fi/rally-roadbook' },
  { code: 'el', name: 'Ελληνικά', path: '/el/rally-roadbook' },
  { code: 'hr', name: 'Hrvatski', path: '/hr/rally-roadbook' },
  { code: 'ru', name: 'Русский', path: '/ru/rally-roadbook' },
  { code: 'hi', name: 'हिन्दी', path: '/hi/rally-roadbook' },
  { code: 'sv', name: 'Svenska', path: '/sv/rally-roadbook' },
  { code: 'et', name: 'Eesti', path: '/et/rally-roadbook' },
  { code: 'hu', name: 'Magyar', path: '/hu/rally-roadbook' },
  { code: 'tr', name: 'Türkçe', path: '/tr/rally-roadbook' },
  { code: 'lv', name: 'Latviešu', path: '/lv/rally-roadbook' },
  { code: 'ro', name: 'Română', path: '/ro/rally-roadbook' },
  { code: 'ja', name: '日本語', path: '/ja/rally-roadbook' },
  { code: 'bg', name: 'Български', path: '/bg/rally-roadbook' },
  { code: 'ar', name: 'العربية', path: '/ar/rally-roadbook' },
  { code: 'lt', name: 'Lietuvių', path: '/lt/rally-roadbook' },
  { code: 'zh', name: '中文', path: '/zh/rally-roadbook' },
];

export default {
  name: 'LanguageNav',
  props: {
    current: { type: String, default: 'en' },
    // Optional list for other page families (e.g. the download pages); defaults
    // to the rally-roadbook pillar languages.
    options: { type: Array, default: null },
  },
  computed: {
    langs() {
      return this.options || LANGS;
    },
  },
};
</script>

<style scoped></style>
